var _defs, _path, _path2, _path3, _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeliverycalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.5 144.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.31,18.08h-13.68v3.43c0,4.5-3.65,8.14-8.15,8.14h-.34c-4.5,0-8.15-3.64-8.15-8.14v-3.43H41.93v3.43c0,4.5-3.64,8.14-8.14,8.14h-.35c-4.5,0-8.14-3.64-8.14-8.14v-3.43h-14.05c-6.22,0-11.26,5.03-11.26,11.25v83.76c0,6.22,5.04,11.26,11.26,11.26h103.38s0-.03-.02-.04c-.44-.89-.81-1.82-1.14-2.76-.13-.39-.46-.68-.87-.75l-5.26-.96c-2.08-.38-3.65-2.1-3.84-4.18-.02-.23-.04-.47-.05-.7H10.12V41.93h128.69v34.66c1.35,0,2.69.05,4.02.19,2.04.21,3.7,1.68,4.15,3.67l1.28,5.84c.04.21.15.41.3.55V29.33c0-6.22-5.04-11.25-11.26-11.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.02,5.06v15.18c0,2.8-2.26,5.06-5.06,5.06s-5.06-2.26-5.06-5.06V5.06c0-2.8,2.26-5.06,5.06-5.06,1.4,0,2.66.56,3.58,1.48s1.48,2.18,1.48,3.58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.32,5.06v15.18c0,2.8-2.26,5.06-5.06,5.06s-5.06-2.26-5.06-5.06V5.06c0-2.8,2.26-5.06,5.06-5.06,1.4,0,2.66.56,3.58,1.48s1.48,2.18,1.48,3.58Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.56,
    cy: 63.99,
    r: 9.76
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.16,
    y: 54.22,
    width: 19.52,
    height: 19.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.53,
    y: 54.22,
    width: 19.52,
    height: 19.52
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 110.62,
    y: 54.22,
    width: 19.52,
    height: 19.52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 18.8,
    y: 83.87,
    width: 19.52,
    height: 19.52
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.16,
    y: 83.87,
    width: 19.52,
    height: 19.52
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 79.53,
    y: 83.87,
    width: 19.52,
    height: 19.52
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m171.29,108.77c-.05-.52-.46-.93-.96-1l-5.26-.75c-1.69-.24-3.11-1.38-3.73-2.98-.17-.44-.36-.87-.55-1.31-.7-1.54-.54-3.34.45-4.7l3.18-4.44c.29-.41.29-.96-.02-1.35-1.51-1.87-3.23-3.59-5.11-5.09-.38-.3-.94-.3-1.35,0l-4.52,3.25c-1.35.97-3.12,1.16-4.65.48-.06-.03-.13-.05-.2-.08-.29-.13-.59-.25-.88-.36-1.48-.57-2.56-1.83-2.91-3.37l-1.28-5.84c-.11-.48-.52-.84-1.02-.88-1.2-.12-2.44-.18-3.67-.16-.92,0-1.84.05-2.75.15-.52.04-.93.43-1.02.93l-.95,5.45c-.29,1.65-1.45,3.03-3.03,3.61-.49.18-.98.38-1.46.59-1.42.63-3.06.53-4.38-.29l-5.17-3.2c-.41-.25-.95-.21-1.33.11-1.51,1.23-2.9,2.61-4.15,4.09-.36.42-.36,1.04,0,1.46l2.96,3.49c1.24,1.45,1.47,3.49.61,5.17-.39.76-.75,1.55-1.05,2.36-.61,1.57-2.02,2.71-3.68,2.97l-5.33.82c-.51.08-.9.47-.95.96-.13,1.2-.2,2.41-.2,3.61,0,.84.04,1.68.1,2.52,0,.13.02.26.03.38.04.49.43.89.93.99l5.26.95c1.66.31,3.03,1.49,3.6,3.09.29.81.62,1.62.98,2.4.25.51.4,1.03.46,1.58.12,1.2-.21,2.4-.99,3.38l-3,3.81c-.33.42-.32,1.02.02,1.43,1.34,1.62,2.84,3.11,4.45,4.44.4.33.95.36,1.37.08l4.58-3.05c.79-.53,1.69-.79,2.6-.79.68,0,1.35.15,1.99.45.62.29,1.28.55,1.93.79,1.7.62,2.89,2.09,3.11,3.86l.59,4.82c.06.54.48.94,1.02.99,2.27.23,4.59.22,6.83-.02.53-.06.94-.47,1-1l.58-4.86c.21-1.76,1.39-3.24,3.08-3.86.7-.26,1.39-.55,2.07-.87,1.6-.78,3.55-.55,4.96.56l3.77,2.96c.42.33,1,.32,1.42-.03,1.68-1.37,3.23-2.92,4.6-4.6.29-.37.31-.9.04-1.31l-3.1-4.7c-.89-1.35-1.03-3.04-.36-4.52.27-.6.52-1.22.74-1.86.6-1.7,2.08-2.91,3.85-3.13l4.92-.62c.53-.07.94-.49.99-1.03.11-1.06.15-2.14.15-3.21,0-1.23-.06-2.46-.21-3.68Zm-31.58,16.95h-.46c-2.11,0-4.15-.46-6-1.37-1.37-.66-2.64-1.56-3.76-2.68-1.88-1.88-3.15-4.19-3.7-6.72-.26-1.12-.37-2.29-.33-3.49.23-7.25,6.09-13.1,13.34-13.34h0c3.64-.12,7.09,1.15,9.75,3.6.15.14.3.29.46.44,2.72,2.72,4.16,6.35,4.03,10.21-.23,7.25-6.09,13.12-13.35,13.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverycalendar);
export default __webpack_public_path__ + "static/media/Deliverycalendar.30a42870eca045e0d3496c2973259f86.svg";
export { ForwardRef as ReactComponent };